import { render, staticRenderFns } from "./_BaseInputText.vue?vue&type=template&id=47c402a6&scoped=true&"
import script from "./_BaseInputText.vue?vue&type=script&lang=js&"
export * from "./_BaseInputText.vue?vue&type=script&lang=js&"
import style0 from "./_BaseInputText.vue?vue&type=style&index=0&id=47c402a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c402a6",
  null
  
)

export default component.exports